import { Currency } from '@/core/currency/interfaces';

const UAH: Currency = {
    name: 'Ukrainian Hryvnia',
    demonym: 'Ukrainian',
    majorSingle: 'Hryvnia',
    majorPlural: 'Hryvnias',
    codeNumeric: '980',
    symbol: '₴',
    symbolNative: 'грн',
    minorSingle: 'Kopiyka',
    minorPlural: 'kopiyky',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'UAH',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default UAH;
